/**
 * ═══════════════════════════════════════════════════════════════════════════
 * Comandero — Purchasing (PURE LOGIC)
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * CC-6: PURE `.ts` file. No lingui macros or UI. Amounts in cents.
 */

export interface PurchaseLine {
  /** Stock units entering (integer ≥ 0).*/
  qty: number;
  /** Cost per unit, in cents.*/
  unitCost: number;
}

/** Purchase order line total = qty × unitCost (cents).*/
export function purchaseLineTotal(line: PurchaseLine): number {
  return Math.max(0, Math.trunc(line.qty)) * Math.max(0, Math.trunc(line.unitCost));
}

/** Purchase order total = Σ lines (cents).*/
export function purchaseOrderTotal(lines: PurchaseLine[]): number {
  return lines.reduce((acc, l) => acc + purchaseLineTotal(l), 0);
}
